import Image from 'next/legacy/image'

import downloadApple from './app-store.png'

const width = height => Math.round((270 / 80) * height)

const AppleButton = ({ height = 40 }) => (
  <Image
    src={downloadApple}
    height={height}
    width={width(height)}
    alt="Download liv.rent iOS App"
    placeholder="blur"
  />
)

export default AppleButton
